import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useInView } from 'react-intersection-observer';
import { useQuery } from 'urql';
import PropTypes from 'prop-types';
import css from './Gallery.module.scss';
import ErrorMessage from '../ErrorMessage';
import query from './query';
import UGC from '../UGC';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var errorMessage = 'There was an error loading this page. Please refresh and try again or contact support.';
var loadingUgcs = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

var Gallery = function Gallery(_ref) {
  var after = _ref.after;

  var _useQuery = useQuery({
    query: query,
    variables: {
      after: after
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      fetching = _useQuery2$.fetching,
      error = _useQuery2$.error;

  var _useInView = useInView({
    rootMargin: '150px 0px 0px 0px',
    triggerOnce: true
  }),
      _useInView2 = _slicedToArray(_useInView, 2),
      ref = _useInView2[0],
      inView = _useInView2[1];

  if (error) {
    console.error('GraphQL error: ', error);
    return /*#__PURE__*/_jsx(ErrorMessage, {
      message: errorMessage,
      details: error
    });
  }

  if (!data || fetching) {
    return /*#__PURE__*/_jsx("ul", {
      className: css.list,
      "aria-busy": fetching,
      children: loadingUgcs.map(function (load) {
        return /*#__PURE__*/_jsx("li", {
          className: css.item
        }, "loading-ugc-".concat(load));
      })
    });
  }

  var instagrams = data.instagrams;
  var _instagrams$pageInfo = instagrams.pageInfo,
      endCursor = _instagrams$pageInfo.endCursor,
      hasNextPage = _instagrams$pageInfo.hasNextPage;
  var readyLoadMore = !fetching && !error && hasNextPage;
  var ugcs = instagrams.edges.map(function (_ref2) {
    var node = _ref2.node;
    return _objectSpread({}, node);
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("ul", {
      className: css.list,
      children: ugcs.length > 0 && ugcs.map(function (item) {
        return /*#__PURE__*/_jsx("li", {
          className: css.item,
          children: /*#__PURE__*/_jsx(UGC, _objectSpread({}, item))
        }, "ugc-".concat(item.id));
      })
    }), inView && readyLoadMore && /*#__PURE__*/_jsx(Gallery, {
      after: endCursor
    }), readyLoadMore && /*#__PURE__*/_jsx("div", {
      "aria-hidden": "true",
      className: css.inView,
      ref: ref
    })]
  });
};

Gallery.defaultProps = {
  after: ''
};
Gallery.propTypes = {
  after: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

var GalleryLoader = function GalleryLoader() {
  var style = "\n  .scrolled .".concat(css.root, " {\n    padding: 0;\n  }\n  ");
  return /*#__PURE__*/_jsxs("section", {
    className: css.root,
    children: [/*#__PURE__*/_jsx("style", {
      dangerouslySetInnerHTML: {
        __html: style
      }
    }), /*#__PURE__*/_jsx(Gallery, {})]
  });
};

export default GalleryLoader;